import './converters/converter.js.coffee'

Namespace 'CustomerVisualMode.Filters.LastInterval'

class CustomerVisualMode.Filters.LastInterval.LastIntervalOptions
  constructor: ->
    @converter = new CustomerVisualMode.Filters.LastInterval.Converters.Converter()

  options: ->
    [].concat.apply([], [
      @_lastMinutesOptions(),
      @_lastHoursOptions(),
      @_lastDaysOptions(),
      @_lastWeeksOptions(),
      @_lastMonthOptions()
    ])

  _lastMonthOptions: ->
    [
      @converter.toSeconds('month', 1),
      @converter.toSeconds('month', 2),
      @converter.toSeconds('month', 3),
      @converter.toSeconds('month', 6)
    ]

  _lastHoursOptions: ->
    [
      @converter.toSeconds('hour', 1),
      @converter.toSeconds('hour', 2),
      @converter.toSeconds('hour', 3),
      @converter.toSeconds('hour', 4),
      @converter.toSeconds('hour', 5),
      @converter.toSeconds('hour', 6),
      @converter.toSeconds('hour', 7),
      @converter.toSeconds('hour', 8),
      @converter.toSeconds('hour', 9),
      @converter.toSeconds('hour', 10),
      @converter.toSeconds('hour', 11),
      @converter.toSeconds('hour', 12),
      @converter.toSeconds('hour', 18),
    ]

  _lastMinutesOptions: ->
    [
      @converter.toSeconds('minute', 10),
      @converter.toSeconds('minute', 30)
    ]

  _lastDaysOptions: ->
    [
      @converter.toSeconds('day', 1),
      @converter.toSeconds('day', 2),
      @converter.toSeconds('day', 3),
      @converter.toSeconds('day', 4),
      @converter.toSeconds('day', 5),
      @converter.toSeconds('day', 6)
    ]

  _lastWeeksOptions: ->
    [
      @converter.toSeconds('week', 1)
    ]
